export default __webpack_public_path__ + "media/images/payments/google-pay-1286cb9e3ed0d5386b2b9b26d43b1016.svg";